import Campaign from '../store/Campaign';
import React from 'react';
import { CampaignEndSignal } from '../store/schema/CampaignEndSignal';
import { CampaignType } from '../store/schema/CampaignType';
import { endCampaign } from '../utils/endCampaign';
import { OverlayChild } from 'mini-overlay-child';
import { startCampaign } from '../utils/startCampaign';

export interface CampaignOverlayChildConfig {
    childComponentName: string;
}
/**
 * This component, just renders the mentioned component as a child inside an Overlay.
 */
export class CampaignOverlayChild implements CampaignType<CampaignOverlayChildConfig> {
    public start(campaign: Campaign<CampaignOverlayChildConfig>) {
        startCampaign(campaign);
    }

    public end(campaign: Campaign<CampaignOverlayChildConfig>, endSignal: CampaignEndSignal) {
        endCampaign(campaign, endSignal);
    }

    public render(
        campaign: Campaign<CampaignOverlayChildConfig>,
        viewProps: CampaignOverlayChildConfig
    ): JSX.Element {
        const logAndEndCampaign = (endSignal: CampaignEndSignal) => {
            this.end(campaign, endSignal);
        };

        return (
            <OverlayChild
                {...viewProps}
                onUnmount={() => logAndEndCampaign(CampaignEndSignal.OnUnmount)}
                onUserClick={() => logAndEndCampaign(CampaignEndSignal.OnClick)}
                onUserDismiss={() => logAndEndCampaign(CampaignEndSignal.OnUserDismiss)}
            />
        );
    }
}
